import { formatNumber } from '@angular/common';
import { Component, Input } from '@angular/core';
import type { ProductInfo } from '@legacy/common-ui-models';
import { SolarPanelsProductWithCalculations } from '@innogy/feh/temporary-core-modules';
import { TextInterpolationService } from '@core/jss-utils';
import { TranslatePipe } from '@ngx-translate/core';

import { SolarPanelsProductOverviewRendering } from '../../models/solar-panels-product-overview-rendering.interface';

@Component({
  selector: 'wl-solar-panels-product-info[product]',
  templateUrl: './solar-panels-product-info.component.html',
  styleUrls: [
    './solar-panels-product-info.component.ed.scss',
    './solar-panels-product-info.component.essent.scss',
  ],
  providers: [TextInterpolationService, TranslatePipe],
})
export class SolarPanelsProductInfoComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() product!: SolarPanelsProductWithCalculations;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: SolarPanelsProductOverviewRendering;

  constructor(
    private readonly textInterpolationService: TextInterpolationService,
    private readonly translatePipe: TranslatePipe
  ) {}

  get fields() {
    return this.rendering?.fields;
  }

  get productInfo(): ProductInfo[] {
    return [
      ...this.solarPanelsSpecificProductInfo,
      ...(this.product.content.productInfo ?? []),
    ];
  }

  get solarPanelsSpecificProductInfo(): ProductInfo[] {
    const locale = 'nl';
    const { interpolate } = this.textInterpolationService;

    const {
      performance,
      performanceGuaranteedAfterYears,
      performanceGuaranteedFactor,
      recommendation: { amount, yearlyYield },
    } = this.product;

    return [
      {
        icon: this.fields?.YieldIcon,
        key: interpolate(
          this.fields?.YieldLabel.value,
          { amount },
          'plain_text'
        )?.toString(),
        value:
          yearlyYield + this.translatePipe.transform('ElectricityUsageUnit'),
      },
      {
        icon: this.fields?.PerformanceIcon,
        key: this.fields?.PerformanceLabel.value,
        value: performance + this.translatePipe.transform('PerformanceUnit'),
      },
      {
        icon: this.fields?.PerformanceGuaranteedIcon,
        key: interpolate(
          this.fields?.PerformanceGuaranteedLabel.value,
          { years: performanceGuaranteedAfterYears },
          'plain_text'
        )?.toString(),
        value:
          formatNumber(performanceGuaranteedFactor * 100, locale, '1.0-0') +
          '%',
      },
    ];
  }
}
